export const IntegrationNameMap: Record<string, string> = {
  accident_plan: 'AccidentPlan',
  open_weather_map: 'Open Weather Map',
  geotab: 'Geotab',
};

export function getIntegrationName(integrationId: string) {
  return IntegrationNameMap[integrationId] ?? integrationId;
}
